import type { GameMode } from '@aleaces/protocol';

export function QueueScreen({ mode, inQueue, needed, secondsLeft, onCancel }: {
  mode: GameMode;
  inQueue: number;
  needed: number;
  secondsLeft: number;
  onCancel: () => void;
}) {
  return (
    <div className="overlay-screen">
      <div className="big-eyebrow">Matchmaking</div>
      <h1>{mode === 'ranked' ? 'Ranglistenturnier' : 'Freundschaftsrunde'} wird gesucht …</h1>
      <div className="queue-shuffle" aria-hidden="true">
        <div className="qs-card a" />
        <div className="qs-card b" />
        <div className="qs-card c" />
      </div>
      <div className="queue-dots">
        {Array.from({ length: needed }, (_, i) => (
          <div key={i} className={'queue-slot' + (i < inQueue ? ' filled' : '')}>
            {i < inQueue ? <div className="qs-dealt" style={{ animationDelay: (i % 3) * 60 + 'ms' }}>♠</div> : '?'}
          </div>
        ))}
      </div>
      <div className="muted" style={{ fontFamily: 'var(--font-ui)', fontSize: 14 }}>
        {inQueue} von {needed} Plätzen belegt · freie Plätze übernehmen in <b style={{ color: 'var(--gold-hi)' }}>{secondsLeft}s</b> Wirtshaus-Helden
      </div>
      <div className="queue-timer">{secondsLeft}</div>
      <p className="muted" style={{ fontFamily: 'var(--font-ui)', fontSize: 13, maxWidth: '48ch', textAlign: 'center', margin: 0 }}>
        Sobald der Tisch steht, wird dir ein <b style={{ color: 'var(--gold-hi)' }}>zufälliger Held</b> aus deiner Sammlung zugelost.
      </p>
      <button className="btn ghost" onClick={onCancel}>Suche abbrechen</button>
    </div>
  );
}
